import { type ToastOptions } from 'react-toastify'

const toastConfig: ToastOptions = {
  position: 'bottom-right',
  autoClose: 16000
}

export default toastConfig
